import ActionTypes from "../constants/ActionTypes";
import BASE_URL from "../constants/Api";
import axiosInstance from "../helpers/refreshTokenMiddleware";

// ============================================================================
// Fetch Logs Count
// ============================================================================
export const fetchLogsCountRequest = () => ({
    type: ActionTypes.FETCH_LOGS_COUNT_REQUEST,
});

export const fetchLogsCountSuccess = (count, keys) => ({
    type: ActionTypes.FETCH_LOGS_COUNT_SUCCESS,
    payload: { count, keys },
});

export const fetchLogsCountFailure = (error) => ({
    type: ActionTypes.FETCH_LOGS_COUNT_FAILURE,
    payload: error,
    error: true,
});

export const fetchLogsCount = (
    start_date,
    end_date,
    login_id = "",
    user_name = "",
    title = "",
    auto_number = ""
) => async (dispatch) => {
  dispatch(fetchLogsCountRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(
        `${BASE_URL}`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            params: {
                path: "log",
                type: "get-log-count",
                ...(start_date && { start_date }),
                ...(end_date && { end_date }),
                ...(login_id && { login_id }),
                ...(user_name && { user_name }),
                ...(title && { title }),
                ...(auto_number && { auto_number }),
            }
        }
    );

    const { count, keys } = response.data.respons;
    console.log("Fetched logs count - count:", count);
    console.log("Fetched logs count - keys:", keys);
    dispatch(fetchLogsCountSuccess(count, keys));

  } catch (error) {
    dispatch(fetchLogsCountFailure(error?.message || "Unknown error"));
  }
};


// ============================================================================
// Fetch Logs List
// ============================================================================
export const fetchLogsRequest = () => ({
    type: ActionTypes.FETCH_LOGS_REQUEST,
});

export const fetchLogsSuccess = (data_list, all_data_count) => ({
    type: ActionTypes.FETCH_LOGS_SUCCESS,
    payload: { data_list, all_data_count },
});

export const fetchLogsFailure = (error) => ({
    type: ActionTypes.FETCH_LOGS_FAILURE,
    payload: error,
    error: true,
});

export const fetchLogs = (
    start_date,
    end_date,
    login_id = "",
    user_name = "",
    title = "",
    auto_number = "",
    search_keys = {},

) => async (dispatch) => {
  dispatch(fetchLogsRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const body = {
        start_date: start_date,
        end_date: end_date,
        login_id: login_id,
        user_name: user_name,
        title: title,
        auto_number: auto_number,
        key: search_keys,
    };

    console.log("Fetched logs - body:", body);

    const response = await axiosInstance.post(`${BASE_URL}?path=log&type=get-log`, body, {
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
        }
    );    

    const { data_list, all_data_count } = response.data.respons;
    console.log("Fetched logs - data_list:", data_list);
    console.log("Fetched logs - all_data_count:", all_data_count);
    dispatch(fetchLogsSuccess(data_list, all_data_count ));

  } catch (error) {
    dispatch(fetchLogsFailure(error?.message || "Unknown error"));
  }
};

export const fetchLogsByGet = (
    start_date,
    end_date,
    login_id = "",
    user_name = "",
    title = "",
    auto_number = ""

) => async (dispatch) => {
  dispatch(fetchLogsRequest());

  try {
    const accessToken = localStorage.getItem("accessToken");

    if (!accessToken) {
      window.location.href = "/login";
      return;
    }

    const response = await axiosInstance.get(
        `${BASE_URL}`,
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            params: {
                path: "log",
                type: "get-log",
                ...(start_date && { start_date }),
                ...(end_date && { end_date }),
                ...(login_id && { login_id }),
                ...(user_name && { user_name }),
                ...(title && { title }),
                ...(auto_number && { auto_number }),
            }
        }
    );

    const { data_list, all_data_count } = response.data.respons;
    console.log("Fetched logs - data_list:", data_list);
    console.log("Fetched logs - all_data_count:", all_data_count);
    dispatch(fetchLogsSuccess(data_list, all_data_count ));

  } catch (error) {
    dispatch(fetchLogsFailure(error?.message || "Unknown error"));
  }
};